export default "__VITE_ASSET__B5B8yqfZ__"